import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ReactComponent as Logo } from '../assets/logo.svg';
import apiClient from '../lib/api-client';
import { auth } from '../lib/firebase';
import '../CSS/auth.css';

const Pending = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            // Sign out from Firebase
            await auth.signOut();
            await apiClient.logout();

            // Redirect to auth page
            window.location.href = '/auth';
        } catch (error) {
            console.error('Logout failed:', error);
            alert('Logout failed. Please try again.');
        }
    };

    return (
        <div className="auth-container d-flex align-items-center justify-content-center">
            <div className="auth-card text-center p-4" style={{ maxWidth: '600px' }}>
                <div className="d-flex align-items-center justify-content-center mb-4">
                    <Logo style={{ height: '40px' }} />
                </div>
                <h2 className="text-primary mb-4">Account Pending Verification</h2>
                <p className="mb-4">
                    Your account is pending verification. Our team will review your details
                    and notify you once your account is approved. If you have any questions,
                    please contact support.
                </p>
                <button
                    className="btn btn-outline-primary"
                    onClick={handleLogout}
                >
                    Return to Login
                </button>
            </div>
        </div>
    );
};

export default Pending;